import api from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';

const aiSettingsService = {
  // Get all AI providers
  getProviders: async () => {
    try {
      const response = await api.get('/ai-settings/providers');
      return response.data;
    } catch (error) {
      console.error('Error fetching providers:', error);
      throw error.response?.data || error;
    }
  },

  // Get models for a specific provider
  getModels: async (provider) => {
    try {
      const response = await api.get(`/ai-settings/providers/${provider}/models`);
      return response.data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error.response?.data || error;
    }
  },

  // Get AI settings for organization
  getAiSettings: async (organizationId) => {
    try {
      const response = await api.get(`/ai-settings/organization/${organizationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching AI settings:', error);
      throw error.response?.data || error;
    }
  },

  // Update provider and model settings
  updateProviderSettings: async (organizationId, data) => {
    try {
      const response = await api.patch(
        `/ai-settings/organization/${organizationId}/provider`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error updating provider settings:', error);
      throw error.response?.data || error;
    }
  },

  // Create campaign
  createCampaign: async (organizationId, campaignData) => {
    try {
      const response = await api.post(
        `/ai-settings/organization/${organizationId}/campaigns`,
        campaignData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Update campaign
  updateCampaign: async (organizationId, campaignId, campaignData) => {
    try {
      const response = await api.patch(
        `/ai-settings/organization/${organizationId}/campaigns/${campaignId}`,
        campaignData
      );
      return response.data;
    } catch (error) {
      console.error('Error updating campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Delete campaign
  deleteCampaign: async (organizationId, campaignId) => {
    try {
      const response = await api.delete(
        `/ai-settings/organization/${organizationId}/campaigns/${campaignId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting campaign:', error);
      throw error.response?.data || error;
    }
  },

  // Set campaign as active
  setActiveCampaign: async (organizationId, campaignId) => {
    try {
      const response = await api.patch(
        `/ai-settings/organization/${organizationId}/campaigns/${campaignId}/set-active`
      );
      return response.data;
    } catch (error) {
      console.error('Error setting active campaign:', error);
      throw error.response?.data || error;
    }
  }
};

export { aiSettingsService };
